import { DefaultTheme } from 'styled-components';
import { kccStyledTheme } from './kccTheme/kccTheme';
import { theme } from './appTheme/appTheme';

export const styledComponentTheme: DefaultTheme = {
  ...theme,
  kcc: kccStyledTheme,
};
